async function getUserMediaPermission(
  constraints?: DisplayMediaStreamConstraints
) {
  try {
    const mediaStream = await navigator.mediaDevices.getUserMedia(constraints)
    mediaStream.getTracks().forEach(track => track.stop())
  } catch (e) {
    if (e instanceof DOMException) {
      throw new PermissionDenied(getErrorMessage(e))
    }
    throw new UnexpectedMediaPermissionError()
  }
}

export class PermissionDenied extends Error {
  constructor(message: string) {
    super(message)
    Object.setPrototypeOf(this, PermissionDenied.prototype)
  }
}

export class UnexpectedMediaPermissionError extends Error {
  constructor() {
    super('Unexpected error occurred please contact support')
    Object.setPrototypeOf(this, UnexpectedMediaPermissionError.prototype)
  }
}

export function getAudioPermissions() {
  return getUserMediaPermission({ audio: true, video: false })
}

export async function getAudioStream(
  constraints?: DisplayMediaStreamConstraints
) {
  try {
    return await navigator.mediaDevices.getUserMedia(constraints)
  } catch (e) {
    if (e instanceof DOMException) {
      throw new PermissionDenied(getErrorMessage(e))
    }
    throw new UnexpectedMediaPermissionError()
  }
}

function getErrorMessage(domException: DOMException) {
  switch (domException.name) {
    case 'NotAllowedError':
    case 'NotFoundError':
    case 'NotReadableError':
      return 'Please check that access to your microphone is allowed for this website and try again'
    default:
      return 'Cannot access the microphone'
  }
}
